import {
  QuestionnaireAssignment,
  QuestionnaireFormOption,
  QuestionnaireScheduleOption,
} from '@app/api/QuestionnaireAssignmentStore';

// The schedule a newly checked questionnaire starts on. The deploy doc's admin instructions
// create the 12-week schedule with this code.
export const STANDARD_SCHEDULE_CODE = 'PROGRAM_12WK';

/** The standard 12-week schedule, or the first schedule if there isn't one. Null when there are none. */
export const defaultScheduleId = (schedules: QuestionnaireScheduleOption[]): number | null =>
  (schedules.find((schedule) => schedule.code === STANDARD_SCHEDULE_CODE) ?? schedules[0])?.id ?? null;

/** What a new team starts with: every questionnaire, on the default schedule. None when there are no schedules. */
export const defaultAssignments = (
  questionnaires: QuestionnaireFormOption[],
  schedules: QuestionnaireScheduleOption[]
): QuestionnaireAssignment[] => {
  const scheduleId = defaultScheduleId(schedules);
  if (scheduleId === null) return [];
  return questionnaires.map((questionnaire) => ({ formId: questionnaire.id, scheduleId }));
};

/** Checks or unchecks a questionnaire. A newly checked one goes on the given schedule. */
export const toggleQuestionnaire = (
  assignments: QuestionnaireAssignment[],
  formId: number,
  scheduleId: number | null
): QuestionnaireAssignment[] => {
  if (assignments.some((assignment) => assignment.formId === formId)) {
    return assignments.filter((assignment) => assignment.formId !== formId);
  }
  if (scheduleId === null) return assignments;
  return [...assignments, { formId, scheduleId }];
};

/** Moves a checked questionnaire to another schedule. */
export const changeQuestionnaireSchedule = (
  assignments: QuestionnaireAssignment[],
  formId: number,
  scheduleId: number
): QuestionnaireAssignment[] =>
  assignments.map((assignment) => (assignment.formId === formId ? { formId, scheduleId } : assignment));
